import React from 'react'
import { Col, Row } from 'react-bootstrap'
import { product4Image, product5Image, product6Image } from '../../assets'
import { ProductComponent } from '../../SharedComponents'

export default function ProductSection2() {
    return (
        <Row className='product-section-2 mx-0'>
            <Col md={4}>
                <ProductComponent title='Fire Retardant Plywood' image={product4Image} />
            </Col>
            <Col md={4} className='mt-5 pt-5 pt-md-0 mt-md-0'>
                <ProductComponent title='Flushdoor' image={product5Image} />
            </Col>
            <Col md={4} className='mt-5 pt-5 pt-md-0 mt-md-0'>
                <ProductComponent title='Flexyply' image={product6Image} />
            </Col>
        </Row>
    )
}
